/**
 * Algolia Insights `clickedObjectIDsAfterSearch` イベントのペイロード組み立て。
 *
 * `common/utils` 配下は純粋関数のみとし、Nuxt の composable (useRuntimeConfig 等) や
 * 副作用 (search-insights / Sentry) に依存させない。送信処理および index 名の取得は
 * 呼び出し側 composable (`wabunka-src/features/Search/composables/general/useAlgoliaClickedEvent.ts`) に置く。
 *
 * @see docs/Design Doc/キーワード検索.md UC4
 */

export interface HitWithQueryID {
  objectID: string;
  __queryID?: string;
  __position?: number;
}

export interface AlgoliaClickedAfterSearchPayload {
  index: string;
  eventName: string;
  objectIDs: [string];
  queryID: string;
  positions: [number];
}

/**
 * `hit` と `indexName` から Insights API へ送るペイロードを組み立てる。
 * `__queryID` または `indexName` が無い場合は null を返し、呼び出し側で送信スキップする。
 */
export const buildAlgoliaClickedAfterSearchPayload = (hit: HitWithQueryID, indexName: string | undefined, eventName = 'Search Result Clicked'): AlgoliaClickedAfterSearchPayload | null => {
  if (!indexName || !hit.__queryID) return null;
  return {
    index: indexName,
    eventName,
    objectIDs: [hit.objectID],
    queryID: hit.__queryID,
    positions: hit.__position !== undefined ? [hit.__position] : [1],
  };
};
